<template>
    <div class="context">
        <div class="left_box">
            <div class="search_box">
                <el-input v-model.trim="search_input"
                          @change="getSearch()"
                          clearable
                          placeholder="搜索成员、岗位、部门、手机号">
                    <el-button slot="append"
                               @click="getSearch()"
                               icon="el-icon-search"></el-button>
                </el-input>
            </div>

            <div class="tree_box" id="tree_dom" v-if="showTree">
                <el-tree
                        :data="treeDataAll"
                        node-key="department_id"
                        :props="treeOptions"
                        @node-click="clickNode"
                        class="office_tree"
                        highlight-current
                        default-expand-all
                        :expand-on-click-node="false">
                    <span class="custom-tree-node"
                          :class="selectTreeNode.department_id == data.department_id ? 'select_node': ''"
                          slot-scope="{ node, data }">
                        <span>
                            <span class="iconfont icon-wenjianjia" style="padding-right: 5px"></span>
                            <span>{{ node.label }}</span>
                        </span>
                        <span @click.stop="" class="caozuo_btn">
                            <el-popover
                                    placement="bottom"
                                    width="150px"
                                    popper-class="tree_box_pop"
                                    trigger="click">
                                <div class="btn_box">
                                    <div class="btn" @click="openAdd(data)">添加子部门</div>
                                    <div class="btn" @click="openEdit(data)">修改名称</div>
                                    <div class="btn">设置负责人</div>
                                    <div class="btn table_del_btn" @click="delNode(data)">删除</div>
                                </div>
                                <i class="el-icon-more" slot="reference"></i>
                              </el-popover>
                        </span>
                    </span>
                </el-tree>
            </div>

            <div class="res_item" v-if="!showTree && rep_data_list.length > 0">
                <div class="title">员工</div>
                <div class="flex_1">
                    <div class="item user_item"
                     v-for="(item, index) in rep_data_list"
                     @click="clickStaff(item)"
                     :class="searchStaff && searchStaff.user_id == item.user_id ? 'active_item': ''"
                     :key="index">
                    <span>{{item.name}}</span>
                    <span class="department_box">{{item.department}}</span>
                </div>
                </div>
            </div>
            <div class="res_item" v-if="!showTree && job_data_list.length > 0">
                <div class="title">岗位</div>
                <div class="flex_1">

                    <div class="item user_item"
                     v-for="(item, index) in job_data_list"
                     @click="clickStaff(item)"
                     :class="searchStaff && searchStaff.user_id == item.user_id ? 'active_item': ''"
                     :key="index">
                    <span>{{item.job}}</span>
                </div>
                </div>
            </div>
            <div class="res_item" v-if="!showTree && department_data_list.length > 0">
                <div class="title">部门</div>
                <div class="flex_1">
                    <div class="item department_item"
                     v-for="(item, index) in department_data_list"
                     @click="clickNode(item)"
                     :class="selectTreeNode.department_id == item.department_id ? 'active_item': ''"
                     :key="index">
                    <span class="iconfont icon-wenjianjia"
                          style="padding-right: 5px"></span>
                    <span>{{item.name}}</span>
                </div>
                </div>
            </div>
        </div>
        <div class="right_box">
            <component :is="componentId"
                       @changeTopTab="switchModule"
                       @changeShowTree="changeShowTree"
                       @changeNode="clickNode"
                       :ref="componentId"></component>
        </div>

        <el-dialog :title="tree_dialog_title"
                   width="450px"
                   :modal="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :show-close="false"
                   :visible.sync="TreeVisible">
            <el-form :model="treeForm" :rules="rules" label-width="120px" ref="treeForm">
                <el-form-item label="部门名称" prop="name">
                    <el-input class="width_220"
                              @keyup.enter.native="submitTree"
                              v-model="treeForm.name"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="TreeVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitTree">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import tableView from "./tableView"
    import addView from "./add"
    import lookView from "./look"
    import {mapState, mapMutations} from 'vuex'
    import {clone} from "@/global/utils";

    export default {
        name: "",
        components: {
            tableView,
            addView,
            lookView,
        },
        data() {
            return {
                componentId: 'tableView',

                search_input: '',

                department_data_list: [],
                rep_data_list: [],
                job_data_list: [],

                treeOptions: {
                    label: 'name',
                    children: 'children'
                },
                tree_dialog_title: '添加子部门',
                TreeVisible: false,
                treeForm: {
                    name: ''
                },
                rules: {
                    name: [{required: true, message: '请输入部门名称！', trigger: 'blur'}]
                },

            }
        },
        computed: {
            ...mapState("manageData", {
                selectTreeNode: 'selectTreeNode',
                searchStaffNode: 'searchStaffNode',
                searchStaff: 'searchStaff',
                showTree: 'showTree',
                treeDataAll: 'treeDataAll',
            })
        },
        watch: {

        },
        mounted() {
            this.getTree();
        },
        methods: {
            ...mapMutations("manageData", {
                setStaffTreeNode: 'setStaffTreeNode',
                setSearchStaffNode: 'setSearchStaffNode',
                setSearchStaff: 'setSearchStaff',
                setShowTree: 'setShowTree',
                setTreeDataAll: 'setTreeDataAll'
            }),
            switchModule(id) {
                this.componentId = id
            },
            changeShowTree() {
                this.$nextTick(() => {
                    if(!this.showTree) return;
                    let select_node = document.getElementsByClassName('select_node');
                    let tree_dom = document.getElementById('tree_dom');
                    if (select_node.length > 0) {
                        tree_dom.scrollTo(0, select_node[0].offsetTop - 100);
                    }
                })
            },

            getSearch() {
                if (this.search_input) {
                    let params = {
                        keyword: this.search_input
                    };
                    this.httpGet('/user/search_rep_or_department_or_job', params).then(res => {
                        this.setShowTree(false);
                        this.department_data_list = res.data.department_data_list;
                        this.rep_data_list = res.data.rep_data_list;
                        this.job_data_list = res.data.job_data_list;

                        if (this.rep_data_list && this.rep_data_list.length > 0) {
                            this.clickStaff(this.rep_data_list[0])
                        } else if (this.job_data_list && this.job_data_list.length > 0) {
                            this.clickStaff(this.job_data_list[0])
                        } else if (this.department_data_list && this.department_data_list.length > 0) {
                            this.clickNode(this.department_data_list[0])
                        }
                    })
                } else {
                    this.setShowTree(true);
                    this.clickNode(this.selectTreeNode)
                }

            },
            clickNode(data) {
                console.log(data, 'table');
                this.setStaffTreeNode(data);
                this.switchModule('tableView')
            },
            clickDepartment(data) {
                this.setSearchStaffNode(data);
                this.switchModule('tableView')
            },
            clickStaff(item) {
                // console.log(item, 'look');
                this.setSearchStaff(item);
                this.switchModule('lookView')
            },

            delNode(node) {
                if (!node.department_id) return;
                this.$confirm('确定要删除当前部门和当前部门下的子部门么？').then(() => {
                    this.httpDel(`/department/${node.department_id}`).then(res => {
                        this.$message.success('删除部门成功！');
                        this.getTree()
                    })
                }).catch(() => {
                })
            },
            openAdd(node) {
                if (node.department_id) {
                    this.treeForm = {
                        name: '',
                        parent_id: node.department_id
                    }
                } else {
                    this.treeForm = {
                        name: '',
                    }
                }
                this.tree_dialog_title = '添加子部门';
                this.TreeVisible = true;
            },
            openEdit(node) {
                this.treeForm = clone(node);
                this.tree_dialog_title = '修改部门名称';
                this.TreeVisible = true;
            },
            submitTree() {
                if (this.treeForm.department_id) {
                    this.httpPut(`/department/${this.treeForm.department_id}`,
                        this.treeForm).then(res => {
                        this.$message.success('修改部门名称成功！');
                        this.getTree();
                        this.TreeVisible = false;
                    })
                } else {
                    this.httpPost('/department', this.treeForm).then(res => {
                        this.$message.success('添加部门成功！');
                        this.getTree();
                        this.TreeVisible = false;
                    })
                }
            },

            getTree() {
                this.httpGet('/department').then(res => {
                    this.careTree(res.data)
                })
            },
            careTree(list) {
                const check = (staff) => {
                    staff.forEach(v => {
                        if(v.children && v.children.length > 0) {
                            check(v.children)
                        } else {
                            v.children = null
                        }
                    })
                };
                check(list);
                setTimeout(() => {
                    this.setTreeDataAll(clone(list));
                    this.clickNode(clone(list)[0]);
                }, 10)
            },
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);
    .context {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        background: $view_background;
        display: flex;
        .left_box {
            flex: 0 0 330px;
            height: 100%;
            background: #F9FAFC;
            .search_box {
                padding: 5px;
                border-bottom: 1px solid #ccc;
            }
            .tree_box {
                background: #fff;
                padding: 5px;
                overflow: hidden;
                overflow-y: auto;
                height: calc(100% - 70px);
            }
            .res_item {
                padding: 0 10px;
                box-sizing: border-box;
                font-size: 14px;
                display: flex;
                flex-flow: column;
                height: calc(100% - 70px);
                overflow: hidden;
                .title {
                    line-height: 40px;
                    color: #b2b2b2;
                }
                .flex_1 {
                    flex: 1;
                    overflow-y: auto;
                }
                .item {
                    line-height: 30px;
                    &:hover {
                        background: #F0F7FF;
                    }
                }
                .active_item {
                    background: #F0F7FF;
                }
                .user_item {
                    display: flex;
                    justify-content: space-between;
                    .department_box {
                        color: #b2b2b2;
                        max-width: 80px;
                        display: inline-block;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
        .right_box {
            flex: 1;
            width: calc(100% - 330px);
            overflow: hidden;
            background: #fff;
            height: 100%;
            padding: 5px 15px;
            box-sizing: border-box;
        }
    }

    .tree_box_pop {
        .btn_box {
            line-height: 30px;
            font-size: 1rem;
            .btn {
                cursor: pointer;
            }
        }
    }
</style>
<style lang="scss">
    .office_tree {
        line-height: 40px;
        .el-tree-node {
            .el-tree-node__content {
                height: 40px;
                line-height: 40px;
                font-size: 14px;
            }
            .custom-tree-node {
                width: 100%;
                display: flex;
                justify-content: space-between;
                box-sizing: border-box;
                padding: 0 5px;
                .caozuo_btn {
                    display: none;
                }
                &:hover {
                    .caozuo_btn {
                        display: inline;
                    }
                }
            }
            .select_node {
                background: #F0F7FF;
            }
        }
    }
</style>